import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, Row, Col, Card, Navbar, Nav, Alert, Spinner, Button, Offcanvas } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTachometerAlt, faCamera, faUtensils, faCalendarAlt, faDumbbell, faSignOutAlt,
    faUserCircle, faCog, faBrain, faBars, faBullseye as faTarget // faTarget añadido
} from '@fortawesome/free-solid-svg-icons';

import UserDropdown from '../components/UserDropdown';
import UserProfileModal from '../components/UserProfileModal';
import UserDashboardModal from '../components/UserDashboardModal';
import WeeklyMenuGenerator from '../components/WeeklyMenuGenerator';
import WeeklyWorkoutGenerator from '../components/WeeklyWorkoutGenerator';
import FoodScanner from '../components/FoodScanner';
import AnalysisResult from '../components/AnalysisResult';
import RecipeGenerator from '../components/RecipeGenerator';
import OnboardingForm from '../components/OnboardingForm';
import CalorieTargetsModal from '../components/CalorieTargetsModal'; // NUEVO IMPORT
import NutritionChatWidget from '../components/NutritionChatWidget'; // Asegúrate de la ruta 

import { useNavigate } from 'react-router-dom'; // AÑADIR
// ... otros imports ...
import { signOut as signOutService } from '../services/authService'; // Renombrar para claridad

import { updateUserPasswordInAuth } from '../services/authService'; // Ajusta la ruta si es necesario
// y dbService ya está importado:


import {
    getUserProfile,
    //createUserProfile,
    getGoals, updateGoals,
    getRestrictions, updateRestrictions, getUserActivity, saveUserActivity,
    updateUserProfile
} from '../services/dbService';

// Inline styles
const pageStyles = {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 'calc(100vh - 56px)',
};

const sidebarStyles = {
    width: '260px',
    backgroundImage: 'linear-gradient(to bottom, #e7f0f7, #f8f9fa 90%)', // NUEVO DEGRADADO
    padding: '1.5rem 1rem',
    borderRight: '1px solid #dee2e6',
    boxShadow: '2px 0 5px rgba(0,0,0,0.05)',
    flexShrink: 0,
    height: 'calc(100vh - 56px)',
    overflowY: 'auto'
};

const contentStyles = {
    flexGrow: 1,
    padding: '1.5rem',
    overflowY: 'auto',
    backgroundColor: '#ffffff',
    height: 'calc(100vh - 56px)'
};

const MainPage = ({ user, setUser }) => {
    const [activeSection, setActiveSection] = useState('foodScanner');
    const [error, setError] = useState('');
    const [isLoadingUserData, setIsLoadingUserData] = useState(true);
    const [showDashboardModal, setShowDashboardModal] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showOffcanvasNav, setShowOffcanvasNav] = useState(false);
    const [showCalorieTargetsModal, setShowCalorieTargetsModal] = useState(false); // NUEVO ESTADO
    const [chatAppContext, setChatAppContext] = useState({}); // Nuevo estado para el contexto del chat

    const [personalInfo, setPersonalInfo] = useState({
        full_name: '', email: '', plan: 'Free', sex: '', age: '', height: '', weight: '', avatar_url: null,
        activity_level: 'sedentary',
        primary_goal: 'maintain_weight',
        target_calories: 0,
        protein_percent_target: 0,
        carb_percent_target: 0,
        fat_percent_target: 0,
        bmr: 0, tdee: 0 // Añadido para mantener consistencia con el perfil
    });
    const [goals, setGoals] = useState([]);
    const [restrictions, setRestrictions] = useState([]);
    const [scans, setScans] = useState([]);
    const [weeklyMenuGenerated, setWeeklyMenuGenerated] = useState(null);
    const [finalAiAnalysisResult, setFinalAiAnalysisResult] = useState(null);

    const [showOnboardingForm, setShowOnboardingForm] = useState(false);
    const [hasOnboardingBeenCompletedThisSession, setHasOnboardingBeenCompletedThisSession] = useState(false);

    const handleCloseOffcanvasNav = () => setShowOffcanvasNav(false);
    const handleShowOffcanvasNav = () => setShowOffcanvasNav(true);

    const loadInitialUserData = useCallback(async () => {
        if (!user?.id) {
            setIsLoadingUserData(false);
            setShowOnboardingForm(false);
            return;
        }
        setIsLoadingUserData(true);
        setError('');
        try {
            let p = await getUserProfile(user.id); // p es el perfil de tu tabla 'profiles'
            console.log("User profile from DB:", p); // Perfil de tu DB
            console.log("Supabase user object:", user); // Objeto user de Supabase (con user_metadata)

            let profileJustCreated = false;


            const isProfileActuallyIncomplete = !p || !p.age || !p.sex || !p.height || !p.weight;

            if (profileJustCreated || (isProfileActuallyIncomplete && !hasOnboardingBeenCompletedThisSession)) {
                setShowOnboardingForm(true);
            } else {
                setShowOnboardingForm(false);
            }

            const userGoalsFromDB = await getGoals(user.id);
            const primaryGoalFromDBGoals = Array.isArray(userGoalsFromDB) ? userGoalsFromDB.find(goal => goal.is_primary)?.target : null;

            // Establecer personalInfo usando el perfil 'p' (ya sea existente o recién creado)
            // y como fallback el user.user_metadata si el perfil 'p' no tiene avatar_url (ej. perfil antiguo)
            setPersonalInfo({
                full_name: p?.full_name || '',
                email: p?.email || user.email || '',
                plan: p?.suscription_plan || 'Free',
                avatar_url: p?.avatar_url || user.user_metadata?.avatar_url || null, // <--- PRIORIDAD: p.avatar_url, LUEGO user.user_metadata
                sex: p?.sex || '',
                age: p?.age || '',
                height: p?.height || '',
                weight: p?.weight || '',
                activity_level: p?.activity_level || 'sedentary',
                primary_goal: p?.primary_goal || primaryGoalFromDBGoals || 'maintain_weight',
                target_calories: p?.target_calories || 2000,
                protein_percent_target: p?.protein_percent_target || 30,
                carb_percent_target: p?.carb_percent_target || 40,
                fat_percent_target: p?.fat_percent_target || 30,
                bmr: p?.bmr || null,
                tdee: p?.tdee || null
            });
            console.log("PersonalInfo state set with avatar_url:", p?.avatar_url || user.user_metadata?.avatar_url);


            const [g, r, s] = await Promise.all([
                Promise.resolve(userGoalsFromDB),
                getRestrictions(user.id),
                getUserActivity(user.id)
            ]);
            setGoals(Array.isArray(g) ? g.map(i => ({ target: i.target || '', deadline: i.deadline || null, is_primary: i.is_primary || false })) : []);
            setRestrictions(Array.isArray(r) ? r.map(i => (typeof i === 'string' ? i : i.restriction || '')) : []);
            setScans(Array.isArray(s) ? s : []);

        } catch (err) {
            console.error("Error loading user data:", err);
            setError('Error loading user data. Please refresh.');
        } finally {
            setIsLoadingUserData(false);
        }
    }, [user, hasOnboardingBeenCompletedThisSession]);

    useEffect(() => {
        loadInitialUserData();
    }, [loadInitialUserData]);




    const handleOnboardingSubmit = async (formDataFromOnboarding) => {
        if (!user?.id) {
            console.error("User not identified. Cannot save profile.");
            throw new Error("User not identified. Cannot save profile.");
        }

        console.log("Onboarding form data received:", formDataFromOnboarding);

        const profileUpdates = {
            age: parseInt(formDataFromOnboarding.age, 10),
            sex: formDataFromOnboarding.sex,
            height: parseInt(formDataFromOnboarding.height, 10),
            weight: parseFloat(formDataFromOnboarding.weight),
            activity_level: formDataFromOnboarding.activity_level,
            primary_goal: formDataFromOnboarding.primary_goal,
            target_calories: Number(formDataFromOnboarding.target_calories) || 0,
            protein_percent_target: Number(formDataFromOnboarding.protein_percent_target) || 0,
            carb_percent_target: Number(formDataFromOnboarding.carb_percent_target) || 0,
            fat_percent_target: Number(formDataFromOnboarding.fat_percent_target) || 0,
            bmr: Number(formDataFromOnboarding.bmr) || 0,
            tdee: Number(formDataFromOnboarding.tdee) || 0,

        };

        try {
            const updatedProfileFromDB = await updateUserProfile(user.id, profileUpdates);

            setPersonalInfo(prev => ({
                ...prev,
                age: updatedProfileFromDB?.age,
                sex: updatedProfileFromDB?.sex,
                height: updatedProfileFromDB?.height,
                weight: updatedProfileFromDB?.weight,
                activity_level: updatedProfileFromDB?.activity_level,
                primary_goal: updatedProfileFromDB?.primary_goal,
                target_calories: updatedProfileFromDB?.target_calories ?? 0,
                protein_percent_target: updatedProfileFromDB?.protein_percent_target ?? 0,
                carb_percent_target: updatedProfileFromDB?.carb_percent_target ?? 0,
                fat_percent_target: updatedProfileFromDB?.fat_percent_target ?? 0,
                full_name: updatedProfileFromDB?.full_name || prev.full_name,
                bmr: updatedProfileFromDB?.bmr || prev.bmr,
                tdee: updatedProfileFromDB?.tdee || prev.tdee,
            }));

            if (formDataFromOnboarding.primary_goal) {
                const currentGoals = await getGoals(user.id) || [];
                const updatedGoalsList = currentGoals.map(g => ({ ...g, is_primary: false }));
                const existingPrimary = updatedGoalsList.find(g => g.target === formDataFromOnboarding.primary_goal);
                if (existingPrimary) {
                    existingPrimary.is_primary = true;
                } else {
                    updatedGoalsList.push({ user_id: user.id, target: formDataFromOnboarding.primary_goal, deadline: null, is_primary: true });
                }
                await updateGoals(user.id, updatedGoalsList.map(({ user_id, ...rest }) => rest)); // Quitar user_id si updateGoals no lo espera
                setGoals(updatedGoalsList);
            }

            const newRestrictionsList = formDataFromOnboarding.allergiesOrRestrictions
                .split(',')
                .map(r => r.trim())
                .filter(Boolean);
            if (formDataFromOnboarding.dietaryPreferences && formDataFromOnboarding.dietaryPreferences !== '' && formDataFromOnboarding.dietaryPreferences !== 'none') {
                if (!newRestrictionsList.includes(formDataFromOnboarding.dietaryPreferences)) {
                    newRestrictionsList.push(formDataFromOnboarding.dietaryPreferences);
                }
            }
            // Aquí updateRestrictions podría necesitar objetos con { restriction: 'value' }
            await updateRestrictions(user.id, newRestrictionsList.map(r => ({ user_id: user.id, restriction: r })));
            setRestrictions(newRestrictionsList);


            setHasOnboardingBeenCompletedThisSession(true);
            setShowOnboardingForm(false);
            setActiveSection('foodScanner');

        } catch (err) {
            console.error("Error saving onboarding data in MainPage:", err);
            setError(err.message || "Failed to save onboarding data.");
            throw err;
        }
    };

    const handleSaveCalorieTargets = async (newTargetsData) => {
        if (!user?.id) {
            setError("User not identified. Cannot save targets.");
            return;
        }
        setError('');
        try {
            const updatedProfileFromDB = await updateUserProfile(user.id, newTargetsData);
            console.log("Updated profile from DB:", updatedProfileFromDB);
            setPersonalInfo(prev => ({
                ...prev,
                target_calories: updatedProfileFromDB?.target_calories ?? prev.target_calories,
                protein_percent_target: updatedProfileFromDB?.protein_percent_target ?? prev.protein_percent_target,
                carb_percent_target: updatedProfileFromDB?.carb_percent_target ?? prev.carb_percent_target,
                fat_percent_target: updatedProfileFromDB?.fat_percent_target ?? prev.fat_percent_target,
                bmr: updatedProfileFromDB?.bmr ?? prev.bmr,
                tdee: updatedProfileFromDB?.tdee ?? prev.tdee,
            }));
            setShowCalorieTargetsModal(false);
        } catch (err) {
            console.error("Error saving calorie targets:", err);
            setError("Failed to save calorie targets. Please try again.");
        }
    };

    const navigate = useNavigate(); // AÑADIR
    // ... (todos tus otros estados y funciones) ...

    // Función para resetear todo el estado local de MainPage
    const resetMainPageState = useCallback(() => {
        setUser(null);
        localStorage.removeItem('user'); // Solo si es tu propio item 'user'

        setPersonalInfo({
            full_name: '', email: '', plan: 'Free', sex: '', age: '', height: '', weight: '',
            activity_level: 'sedentary', primary_goal: 'maintain_weight',
            target_calories: 0, protein_percent_target: 0, carb_percent_target: 0, fat_percent_target: 0,
            bmr: 0, tdee: 0
        });
        setGoals([]);
        setRestrictions([]);
        setScans([]);
        setWeeklyMenuGenerated(null);
        setActiveSection('foodScanner'); // O a una sección por defecto si no es 'foodScanner'
        setFinalAiAnalysisResult(null);
        // handleCloseOffcanvasNav(); // Llama a esta si es necesario y está definida correctamente
        setShowOffcanvasNav(false); // Más directo que llamar a handleCloseOffcanvasNav si solo cierra
        setHasOnboardingBeenCompletedThisSession(false);
        setShowOnboardingForm(false);
        setError(''); // Limpiar cualquier error de logout previo
    }, [
        setUser, setPersonalInfo, setGoals, setRestrictions, setScans,
        setWeeklyMenuGenerated, setActiveSection, setFinalAiAnalysisResult,
        setShowOffcanvasNav, // o handleCloseOffcanvasNav si esa es la que usas y es estable/memoizada
        setHasOnboardingBeenCompletedThisSession, setShowOnboardingForm, setError
    ]);

    const handleLogout = useCallback(async () => {
        setError(''); // Limpia cualquier error de logout previo al intento
        try {
            await signOutService(); // Llama a authService.signOut()
            console.log("Supabase signOut attempt completed.");

            // Opcional: Si también quieres desloguear de Google a nivel de cliente
            // if (typeof googleLogout === 'function') {
            //     googleLogout();
            // }

        } catch (err) {
            console.warn("Error during signOutService (e.g., 'Auth session missing!'):", err.message);
            // No necesitas mostrar un error al usuario si es "Auth session missing"
            // ya que el resultado final (estar deslogueado en la app) se va a lograr.
            // Para otros errores, podrías querer un mensaje más específico.
            if (err.message !== "Auth session missing!") {
                setError("Could not fully sign out from the server, but the local session will be cleared.");
            }
        } finally {
            // Este bloque se ejecuta SIEMPRE, haya habido error en el try o no.
            // Aquí es donde te aseguras que tu aplicación se reinicie al estado de "no logueado".
            console.log("Resetting local app state and navigating after logout attempt.");
            resetMainPageState();
            navigate('/login'); // O tu ruta de landing/login
        }
    }, [signOutService, resetMainPageState, navigate, setError]); // `signOutService` no cambia si es una importación directa


    const handleLogActivity = useCallback(async (activityType, activityData, initiallyVisible = true) => {
        if (!user?.id || !activityData || !activityType) return null;
        try {
            const savedActivity = await saveUserActivity(user.id, activityType, activityData, initiallyVisible);
            if (savedActivity) {
                const updatedActivities = await getUserActivity(user.id);
                setScans(Array.isArray(updatedActivities) ? updatedActivities : []);
            }
            return savedActivity;
        } catch (err) {
            console.error(`Error logging activity (${activityType}):`, err);
            setError(`Could not save ${activityType.replace('_', ' ')} activity.`);
            return null;
        }
    }, [user?.id, setError]); // No necesitas setScans como dependencia si getUserActivity se llama aquí mismo


    const handleScanActivity = useCallback(async (activityType, scanPayload, makeVisibleInitially = true) => {
        console.log('handleScanActivityAndLog', activityType, scanPayload, makeVisibleInitially);
        if (!user?.id || !scanPayload || !activityType) return null;

        const savedActivity = await handleLogActivity(activityType, scanPayload, makeVisibleInitially);

        return savedActivity;


    }, [user?.id, handleLogActivity]);



    const handleRecipeGenerated = useCallback(async (recipeData, makeVisibleInitially = false) => {
        const savedActivity = await handleLogActivity('recipe_generated', { recipe: recipeData }, makeVisibleInitially);
        return savedActivity;
    }, [handleLogActivity]);

    const handleMenuGenerated = useCallback(async (menuData, makeVisibleInitially = true) => {
        setWeeklyMenuGenerated(menuData);
        await handleLogActivity('menu_generated', { menu: menuData }, makeVisibleInitially);
    }, [handleLogActivity]); // No necesitas setWeeklyMenuGenerated como dependencia si se setea aquí mismo.

    const handleWorkoutGenerated = useCallback(async (workoutData, makeVisibleInitially = true) => {
        await handleLogActivity('workout_generated', { workout: workoutData }, makeVisibleInitially);
    }, [handleLogActivity]);

    const handleGoalsUpdateFromModal = useCallback((updatedGoals) => { setGoals(updatedGoals); }, []);
    const handleRestrictionsUpdateFromModal = useCallback((updatedRestrictions) => { setRestrictions(updatedRestrictions); }, []);

    // --- MODIFICADO: Memoizar appSections ---
    const appSections = useMemo(() => [
        {
            key: 'foodScanner',
            title: 'Food Scanner',
            icon: faCamera,
            component: <FoodScanner
                userId={user?.id}
                userHealthGoals={goals}
                userRestrictions={restrictions}
                onScanActivityLogged={handleScanActivity}
                onAnalysisComplete={setFinalAiAnalysisResult} // NUEVA PROP para que FoodScanner pueda actualizar el estado en MainPage
            />
        },
        {
            key: 'recipeGenerator',
            title: 'Recipe Generator',
            icon: faUtensils,
            component: <RecipeGenerator
                userId={user?.id}
                userHealthGoals={goals}
                userRestrictions={restrictions}
                onRecipeGenerated={handleRecipeGenerated}
            />
        },
        {
            key: 'menuPlanner',
            title: 'Nutrition Plan',
            icon: faCalendarAlt,
            component: <WeeklyMenuGenerator
                userId={user?.id}
                userHealthGoals={goals}
                userRestrictions={restrictions}
                userPersonalInfo={personalInfo}
                onMenuGenerated={handleMenuGenerated}
            />
        },
        {
            key: 'workoutPlan',
            title: 'Workout Plan',
            icon: faDumbbell,
            component: <WeeklyWorkoutGenerator
                userId={user?.id}
                userHealthGoals={goals}
                userPersonalInfo={personalInfo}
                onWorkoutGenerated={handleWorkoutGenerated}
            />
        },
    ], [
        user?.id, // Dependencia: si el ID del usuario cambia
        goals,             // Dependencia: si los objetivos cambian
        restrictions,      // Dependencia: si las restricciones cambian
        personalInfo,      // Dependencia: si la info personal cambia (para WeeklyMenuGenerator y WeeklyWorkoutGenerator)
        handleScanActivity, // Dependencia: si la función (su referencia) cambia
        handleRecipeGenerated, // Dependencia
        handleMenuGenerated,   // Dependencia
        handleWorkoutGenerated, // Dependencia
        setFinalAiAnalysisResult // Dependencia: la función setter de estado (es estable, pero buena práctica incluirla si se usa en el closure)
    ]);

    // Actualiza este estado cuando cambien datos relevantes
    useEffect(() => {
        const newContext = {
            currentSection: appSections.find(sec => sec.key === activeSection)?.title || activeSection,
            lastScannedItem: finalAiAnalysisResult, // Esto ya lo tienes
            lastGeneratedMenu: weeklyMenuGenerated, // Si tienes este estado
            // Podrías añadir lastGeneratedWorkout si lo tienes
            userProfileSummary: { // Un resumen, no todo el objeto personalInfo
                primaryGoal: personalInfo.primary_goal,
                // No pases datos sensibles directamente a menos que sea necesario y estés seguro de la privacidad.
                // Quizás solo pasar 'hasProfile: true' o similar si no quieres detalles.
                restrictions: restrictions.length > 0 ? restrictions.join(', ') : 'none specified',
            }
        };
        setChatAppContext(newContext);
    }, [activeSection, finalAiAnalysisResult, weeklyMenuGenerated, personalInfo, restrictions, appSections]);




    const renderActiveSection = () => {
        const currentSection = appSections.find(section => section.key === activeSection);
        if (!currentSection) return <Alert variant="warning">Section not found.</Alert>;
        return (
            <>
                {currentSection.component}
                {activeSection === 'foodScanner' && finalAiAnalysisResult && (
                    <div className="mt-4 pt-4 border-top"><h3 className="text-center mb-3 text-success"><FontAwesomeIcon icon={faBrain} className="me-2" />AI Analysis Result</h3><AnalysisResult data={finalAiAnalysisResult} /></div>
                )}
            </>
        );
    };

    const sidebarContent = (
        <>
            <Nav variant="pills" activeKey={activeSection} onSelect={(selectedKey) => { setActiveSection(selectedKey); setFinalAiAnalysisResult(null); setWeeklyMenuGenerated(null); handleCloseOffcanvasNav(); }} className="flex-column main-sidebar-nav">
                {appSections.map(section => (
                    <Nav.Item key={section.key}>
                        <Nav.Link eventKey={section.key} className="d-flex align-items-center sidebar-link mb-1">
                            <FontAwesomeIcon icon={section.icon} className="me-2 fa-fw" />{section.title}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
            <hr className="my-3" />
            <Nav className="flex-column small">
                <Nav.Link onClick={() => { setShowProfileModal(true); handleCloseOffcanvasNav(); }} className="text-muted sidebar-link-secondary">
                    <FontAwesomeIcon icon={faUserCircle} className="me-2 fa-fw" /> My Profile
                </Nav.Link>
                <Nav.Link onClick={() => { setShowCalorieTargetsModal(true); handleCloseOffcanvasNav(); }} className="text-muted sidebar-link-secondary">
                    <FontAwesomeIcon icon={faTarget} className="me-2 fa-fw" /> Adjust Calorie/Macro Targets
                </Nav.Link>
                <Nav.Link onClick={() => { setShowDashboardModal(true); handleCloseOffcanvasNav(); }} className="text-muted sidebar-link-secondary">
                    <FontAwesomeIcon icon={faTachometerAlt} className="me-2 fa-fw" /> Dashboard
                </Nav.Link>
            </Nav>
            <div className="mt-auto pt-3 d-lg-none">
                <hr className="my-3" />
                <Button variant="outline-danger" size="sm" className="w-100" onClick={() => { handleLogout(); handleCloseOffcanvasNav(); }}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2 fa-fw" /> Logout
                </Button>
            </div>
        </>
    );

    if (isLoadingUserData) {
        return (<Container fluid className="d-flex justify-content-center align-items-center vh-100"><Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} /><p className="ms-3 fs-5 text-muted">Loading your data...</p></Container>);
    }

    if (showOnboardingForm && user) {
        return (
            <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <Col md={8} lg={7} xl={6} xxl={5}>
                    <OnboardingForm
                        show={true}
                        onSubmit={handleOnboardingSubmit}
                        userEmail={user?.email}
                        currentProfileData={personalInfo} // personalInfo ahora incluye todos los datos necesarios
                    />
                </Col>
            </Container>
        );
    }

    const isAnyModalOpen = showProfileModal || showDashboardModal || showOnboardingForm || showCalorieTargetsModal;

    return (
        <div className={`main-page-wrapper ${isAnyModalOpen ? 'content-blur' : ''}`}>
            <Navbar bg="white" expand="lg" className="border-bottom shadow-sm sticky-top" style={{ padding: '0.75rem 1rem' }}>
                <Container fluid>
                    {/* Botón para menú lateral en pantallas pequeñas */}
                    <Button
                        variant="outline-primary"
                        onClick={handleShowOffcanvasNav}
                        className="d-lg-none me-2"
                        aria-label="Toggle navigation menu"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </Button>

                    {/* Logo y Título */}
                    <Navbar.Brand href="#home" className="fw-bold text-primary d-flex align-items-center">
                        <img
                            src="/logo-dark.png"
                            height="60"
                            className="d-inline-block align-top me-3"
                            alt="MyFit Menu Logo"
                        />

                        <h1>MyFit Menu AI</h1>
                    </Navbar.Brand>


                    {/* Menú colapsable con user info */}
                    <Navbar.Collapse id="main-navbar-nav">
                        <Nav className="ms-auto">
                            {user && (
                                <UserDropdown
                                    user={user}
                                    userName={personalInfo.full_name || user.email || 'User Account'}
                                    avatarUrl={personalInfo.avatar_url || user.user_metadata?.avatar_url}
                                    onLogout={handleLogout}
                                    onOpenProfile={() => setShowProfileModal(true)}
                                    onOpenDashboard={() => setShowDashboardModal(true)}
                                />
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>


            <div style={pageStyles} className="page-content-wrapper">
                <div style={sidebarStyles} className="d-none d-lg-flex flex-column">{sidebarContent}</div>
                <Offcanvas show={showOffcanvasNav} onHide={handleCloseOffcanvasNav} placement="start" className="main-sidebar-offcanvas" style={{ width: '260px' }}>
                    <Offcanvas.Header closeButton><Offcanvas.Title><img src="/logo-dark.png" width="30" height="30" className="d-inline-block align-top me-2" alt="MyFit Menu AI Logo" />NutriApp Menu</Offcanvas.Title></Offcanvas.Header>
                    <Offcanvas.Body className="d-flex flex-column">{sidebarContent}</Offcanvas.Body>
                </Offcanvas>
                <main style={contentStyles} className="main-content-area">
                    {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
                    {renderActiveSection()}
                </main>
            </div>

            <UserProfileModal
                show={showProfileModal}
                onClose={() => setShowProfileModal(false)}
                userId={user?.id} // userId se usa implícitamente en la función de abajo
                info={personalInfo} // Pasa el objeto personalInfo completo
                onProfileUpdate={async (dataFromModal) => { // dataFromModal viene de UserProfileModal
                    if (!user?.id) {
                        setError("User not identified. Cannot update profile.");
                        // Es importante lanzar un error para que el modal sepa que falló
                        throw new Error("User not identified.");
                    }

                    // No necesitas setIsLoading aquí si el modal ya tiene su propio isLoading
                    // setIsLoading(true); // Si quieres un isLoading a nivel de MainPage también
                    setError('');
                    let successMessage = ''; // Para mensajes de éxito opcionales

                    try {
                        // 1. Separar la contraseña de los otros datos del perfil
                        const { password: newPassword, ...profileDataOnly } = dataFromModal;

                        // 2. Actualizar la contraseña si se proporcionó una nueva
                        if (newPassword && newPassword.trim() !== '') {
                            console.log("Attempting to update password...");
                            // Llama a tu nueva función de authService
                            await updateUserPasswordInAuth(newPassword);
                            console.log("Password updated successfully via authService.");
                            successMessage += "Password updated. ";
                            // No es necesario limpiar la contraseña del estado del modal desde aquí,
                            // el modal lo hace al cerrar o reabrir.
                        }

                        // 3. Actualizar los datos del perfil en tu tabla 'profiles'
                        //    Asegúrate de que profileDataOnly no contenga campos que no deben ir a la tabla 'profiles'
                        //    o que updateUserProfile sepa manejarlos (o ignorarlos).
                        //    Los campos como target_calories, email, plan ya los estás borrando en la lógica anterior,
                        //    lo cual es incorrecto si UserProfileModal no los edita.
                        //    El UserProfileModal que te di NO envía target_calories, email, plan, etc. como parte
                        //    de los datos editables, solo los muestra.
                        //    Así que profileDataOnly contendrá full_name, age, sex, height, weight, activity_level, primary_goal.


                        console.log("Attempting to update profile data in DB:", profileDataOnly);
                        const dbProfile = await updateUserProfile(user.id, profileDataOnly);
                        console.log("Profile data updated in DB:", dbProfile);
                        successMessage += "Profile details updated.";

                        // Actualizar el estado local de personalInfo con los datos de la DB
                        setPersonalInfo(prev => ({
                            ...prev,
                            full_name: dbProfile?.full_name ?? prev.full_name,
                            age: dbProfile?.age ?? prev.age,
                            sex: dbProfile?.sex ?? prev.sex,
                            height: dbProfile?.height ?? prev.height,
                            weight: dbProfile?.weight ?? prev.weight,
                            activity_level: dbProfile?.activity_level ?? prev.activity_level,
                            primary_goal: dbProfile?.primary_goal ?? prev.primary_goal,

                            // Si updateUserProfile también puede actualizar avatar_url (ej. subida de archivos futura)
                            // avatar_url: dbProfile?.avatar_url ?? prev.avatar_url,
                        }));

                        setShowProfileModal(false); // Cerrar el modal en caso de éxito completo
                        // Opcional: mostrar un toast/alert de éxito
                        // alert(successMessage.trim()); // O un componente de notificación más elegante

                    } catch (err) {
                        console.error("Error updating profile/password in MainPage:", err);
                        setError(err.message || "Failed to update. Please try again.");
                        throw err; // Relanzar el error para que el modal pueda también mostrarlo si quiere
                    } finally {
                        // setIsLoading(false); // Si usas el isLoading de MainPage
                    }
                }}
                onOpenCalorieTargetsModal={() => {
                    setShowProfileModal(false);
                    setShowCalorieTargetsModal(true);
                }}
            />
            <UserDashboardModal
                show={showDashboardModal}
                onClose={() => setShowDashboardModal(false)}
                userId={user?.id}
                initialGoals={goals}
                initialRestrictions={restrictions}
                scans={scans}
                onGoalsUpdate={handleGoalsUpdateFromModal}
                onRestrictionsUpdate={handleRestrictionsUpdateFromModal}
            />
            {user && personalInfo && ( // Asegurarse de que personalInfo está cargado
                <CalorieTargetsModal
                    show={showCalorieTargetsModal}
                    onClose={() => setShowCalorieTargetsModal(false)}
                    onSave={handleSaveCalorieTargets}
                    currentProfileData={personalInfo}
                />
            )}

            {/* AQUÍ AÑADIMOS EL CHAT WIDGET */}
            {user && ( // Solo mostrar el chat si el usuario está logueado
                <NutritionChatWidget
                    appContext={chatAppContext}  // Pasa los datos del último análisis
                    currentMode={activeSection === 'foodScanner' ? 'label' : 'general'} // O ajusta según necesites
                />
            )}
        </div >
    );
};

export default MainPage;